export const tidyHTML = (html) => {
  const d = document.createElement('div');
  d.innerHTML = html;
  return d.innerHTML;
}
